import { getContentByRef } from './get-content-by-ref.js';

/**
 * Retrieves the brandCollection from the pagemodel
 * Iterates over the individual brands and parses the data.
 * Returns a parsed BrandPromotion array
 */ function getBrandPromotions(brandCollectionRef, pageModel) {
    if (!brandCollectionRef) {
        return [];
    }
    // The brands are sent as refs as well, so we need to fetch these refs
    const brandCollection = getContentByRef(brandCollectionRef, pageModel);
    const { brands  } = brandCollection || {};
    if (!brands || brands.length === 0) {
        return [];
    }
    // Parse individual brand information, filter out nullish entries
    const parsedBrands = brands.map(parseBrandFromCollection).filter((brand)=>Boolean(brand)
    );
    return parsedBrands;
}
/**
 * Get the brand content at the provided $ref from the pageModel
 * returns CmsBrandPromotion data or null if data is missing.
 */ function parseBrandFromCollection(brand) {
    // const brand = getContentByRef<BrandDocument>(brandRef, pageModel)
    const { promotionLink , promotionLogo , title , clickablePromotionLogo  } = brand !== null && brand !== void 0 ? brand : {};
    // Return null if we don't have the correct data
    if (!title) {
        return null;
    }
    return {
        name: title,
        url: promotionLink === null || promotionLink === void 0 ? void 0 : promotionLink.url,
        logo: promotionLogo === null || promotionLogo === void 0 ? void 0 : promotionLogo.url,
        clickableLogo: clickablePromotionLogo === null || clickablePromotionLogo === void 0 ? void 0 : clickablePromotionLogo.url
    };
}

export { getBrandPromotions };
//# sourceMappingURL=get-brand-promotions.js.map
